import { type CSSProperties } from "react";
import { File, SquareKanban, Video } from "lucide-react";

import type { NurionLink } from "~/lib/nurion-links";
import { ICON_STROKE } from "~/lib/icon";

const CHIP_STYLE: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--chat-space-1)",
  padding: "0 var(--chat-space-2)",
  borderRadius: "var(--chat-radius-sm)",
  background: "var(--chat-surface-raised)",
  border: "1px solid var(--chat-surface-border)",
  color: "var(--chat-fg-primary)",
  verticalAlign: "baseline",
  whiteSpace: "nowrap",
  textDecoration: "none",
};

const PRODUCT_STYLE: CSSProperties = { fontWeight: 600 };
const SECONDARY_STYLE: CSSProperties = { color: "var(--chat-fg-secondary)" };

function ChipIcon({ kind }: { kind: NurionLink["kind"] }) {
  if (kind === "board-card")
    return <SquareKanban size={14} strokeWidth={ICON_STROKE} aria-hidden />;
  if (kind === "meet-room") return <Video size={14} strokeWidth={ICON_STROKE} aria-hidden />;
  return <File size={14} strokeWidth={ICON_STROKE} aria-hidden />;
}

export function NurionLinkChip({ link }: { link: NurionLink }) {
  return (
    <span style={CHIP_STYLE}>
      <ChipIcon kind={link.kind} />
      <span style={PRODUCT_STYLE}>{link.product}</span>
      <span style={SECONDARY_STYLE}> · {link.label}</span>
    </span>
  );
}
